gsap.registerPlugin(CustomEase);
CustomEase.create("myEase", "0.23, 1, 0.32, 1");

function checkDependencies() {
  if (typeof gsap === "undefined") console.warn("GSAP is required");
  if (typeof Lenis === "undefined")
    console.warn("Lenis is required for smooth scrolling");
  if (typeof Swiper === "undefined")
    console.warn("Swiper is required for sliders");
  if (typeof jQuery === "undefined")
    console.warn("jQuery is required for sliders");
}

class EventEmitter {
  constructor() {
    this.events = {};
  }

  on(event, listener) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(listener);
    return () => this.off(event, listener);
  }

  off(event, listener) {
    if (!this.events[event]) return;
    this.events[event] = this.events[event].filter((l) => l !== listener);
  }

  emit(event, ...args) {
    if (!this.events[event]) return;
    this.events[event].forEach((listener) => listener(...args));
  }
}

// class DOMCleaner {
//   constructor(options = {}) {
//     this.options = {
//       removeComments: true,
//       removeAttributes: ["data-wf-domain", "data-wf-page"],
//       cleanOnLoad: true,
//       cleanAfterDelay: true,
//       delayTime: 500,
//       ...options,
//     };

//     this.init();
//   }

//   init() {
//     if (this.options.cleanOnLoad) {
//       document.addEventListener("DOMContentLoaded", () => this.clean());
//     }

//     this.clean();

//     if (this.options.cleanAfterDelay) {
//       setTimeout(() => this.clean(), this.options.delayTime);
//     }
//   }

//   removeComments() {
//     const commentNodes = [];

//     const findComments = (node) => {
//       if (node.nodeType === Node.COMMENT_NODE) {
//         commentNodes.push(node);
//       } else if (node.childNodes && node.childNodes.length > 0) {
//         node.childNodes.forEach((child) => findComments(child));
//       }
//     };

//     findComments(document);

//     commentNodes.forEach((comment) => {
//       comment.parentNode?.removeChild(comment);
//     });

//     return this;
//   }

//   cleanAttributes() {
//     if (!this.options.removeAttributes.length) return this;

//     const selector = this.options.removeAttributes
//       .map((attr) => `[${attr}]`)
//       .join(", ");

//     const elements = document.querySelectorAll(selector);

//     elements.forEach((element) => {
//       this.options.removeAttributes.forEach((attr) => {
//         element.removeAttribute(attr);
//       });
//     });

//     return this;
//   }

//   clean() {
//     if (this.options.removeComments) {
//       this.removeComments();
//     }

//     this.cleanAttributes();

//     return this;
//   }
// }

class SmoothScroll {
  constructor(options = {}) {
    this.lenis = null;
    this.scrollBtn = document.querySelector(".footer_bottom_back-button");
    this.isMobile = this.checkIfMobile();

    this.defaultOptions = {
      lerp: 0.15,
      wheelMultiplier: 0.95,
      gestureOrientation: "vertical",
      normalizeWheel: false,
      smoothTouch: false,
      ...options,
    };

    this.init();
    this.setupEventListeners();
  }

  checkIfMobile() {
    return (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      ) || window.innerWidth <= 768
    );
  }

  init() {
    if (!this.isMobile) {
      this.initLenis();
      this.initScrollButton();
      this.initAnchorLinks();
      this.startAnimation();

      this.scrollToTop(false);
    } else if (this.scrollBtn) {
      this.initScrollButton();
    }
  }

  initLenis() {
    this.lenis = new Lenis(this.defaultOptions);
  }

  initScrollButton() {
    if (this.scrollBtn) {
      this.scrollBtn.addEventListener("click", () => this.scrollToTop(true));
    }
  }

  initAnchorLinks() {
    document.addEventListener("click", (e) => {
      const anchor = e.target.closest('a[href^="#"]');

      if (anchor && this.lenis) {
        const targetId = anchor.getAttribute("href");

        if (targetId && targetId !== "#") {
          e.preventDefault();

          const targetElement = document.querySelector(targetId);
          if (targetElement) {
            this.lenis.scrollTo(targetElement, {
              offset: 0,
              duration: 1.2,
              easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            });
          }
        }
      }
    });
  }

  scrollToTop(smooth = true) {
    if (this.lenis) {
      this.lenis.scrollTo(0, { immediate: !smooth });
    } else {
      window.scrollTo({
        top: 0,
        behavior: smooth ? "smooth" : "auto",
      });
    }
  }

  scrollToElement(elementId, offset = 0) {
    const targetElement = document.querySelector(elementId);

    if (!targetElement) return;

    if (this.lenis) {
      this.lenis.scrollTo(targetElement, {
        offset: offset,
        duration: 1.2,
      });
    } else {
      const targetPosition =
        targetElement.getBoundingClientRect().top + window.pageYOffset + offset;
      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    }
  }

  raf(time) {
    if (this.lenis) {
      this.lenis.raf(time);
      requestAnimationFrame((time) => this.raf(time));
    }
  }

  startAnimation() {
    if (this.lenis) {
      requestAnimationFrame((time) => this.raf(time));
    }
  }

  stop() {
    if (this.lenis) {
      this.lenis.destroy();
      this.lenis = null;
    }
  }

  start() {
    if (!this.lenis && !this.isMobile) {
      this.initLenis();
      this.startAnimation();

      this.scrollToTop(false);
    }
  }

  resetScroll() {
    if (this.lenis) {
      this.lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo({
        top: 0,
        behavior: "auto",
      });
    }
  }

  destroy() {
    if (this.lenis) {
      this.lenis.destroy();
      this.lenis = null;
    }

    if (this.scrollBtn) {
      this.scrollBtn.removeEventListener("click", this.scrollToTopHandler);
    }

    if (this.popupOpenUnsubscribe) {
      this.popupOpenUnsubscribe();
    }
    if (this.popupCloseUnsubscribe) {
      this.popupCloseUnsubscribe();
    }
  }

  setupEventListeners() {
    this.popupOpenUnsubscribe = appEvents.on("popup:opening", () => {
      document.body.classList.add("no-scroll");
      this.stop();
    });

    this.popupCloseUnsubscribe = appEvents.on("popup:closing", () => {
      document.body.classList.remove("no-scroll");
      this.start();
    });

    window.addEventListener("load", () => {
      if (window.location.hash && !this.isMobile) {
        setTimeout(() => {
          this.scrollToElement(window.location.hash);
        }, 100);
      }
    });
  }
}

// class GSAPMarquee {
//   constructor(options = {}) {
//     this.defaults = {
//       wrapperAttr: 'marquee="wrapper"',
//       listAttr: 'marquee="list"',
//       groupAttr: 'marquee="group"',
//       childAttr: 'marquee="child"',
//       baseSpeed: 40,
//       minSpeed: 0.5,
//       maxSpeed: 3.0,
//       direction: "horizontal",
//       hoverSlowFactor: 0.25,
//       scrollInfluence: 0.8,
//       scrollDirectionThreshold: 0.05,
//       smoothScroll: null,
//       ease: "none",
//     };

//     this.options = { ...this.defaults, ...options };
//     this.wrappers = document.querySelectorAll(`[${this.options.wrapperAttr}]`);
//     this.animations = [];
//     this.scrollVelocity = 0;
//     this.scrollDirection = 1;
//     this.lastScrollPosition = 0;
//     this.isHovering = false;
//     this.wheelIndicator = null;
//     this.isInitialized = false;
//     this.directionChangeTimeout = null;

//     if (this.wrappers.length > 0) {
//       this.init();
//     }
//   }

//   init() {

//     if (!window.gsap) {
//       console.error("GSAP is required for the marquee animation");
//       return;
//     }

//     this.initWheelIndicator();

//     this.wrappers.forEach((wrapper, index) => {
//       this.setupMarquee(wrapper, index);
//     });

//     this.setupScrollListeners();

//     this.setupRAF();

//     this.isInitialized = true;
//   }

//   initWheelIndicator() {

//     if (window.WheelIndicator) {
//       this.wheelIndicator = new WheelIndicator({
//         elem: document.documentElement,
//         callback: (e) => {

//           const newDirection = e.direction === "down" ? 1 : -1;

//           if (newDirection !== this.scrollDirection) {
//             this.scrollDirection = newDirection;
//             this.updateMarqueeDirection();
//           }
//         },
//       });
//     } else {
//       console.warn(
//         "WheelIndicator library not found. Falling back to basic scroll detection."
//       );
//     }
//   }

//   setupMarquee(wrapper, index) {
//     const list = wrapper.querySelector(`[${this.options.listAttr}]`);
//     const group = list.querySelector(`[${this.options.groupAttr}]`);

//     if (!group) {
//       console.error(`Marquee group not found in wrapper #${index}`);
//       return;
//     }

//     const clone1 = group.cloneNode(true);
//     const clone2 = group.cloneNode(true);
//     list.appendChild(clone1);
//     list.appendChild(clone2);

//     const isHorizontal = this.options.direction === "horizontal";
//     const dimension = isHorizontal ? group.offsetWidth : group.offsetHeight;

//     gsap.set(group, {
//       xPercent: isHorizontal ? 0 : null,
//       yPercent: isHorizontal ? null : 0,
//     });
//     gsap.set(clone1, {
//       position: "absolute",
//       top: isHorizontal ? 0 : "100%",
//       left: isHorizontal ? "100%" : 0,
//       xPercent: 0,
//       yPercent: 0,
//     });
//     gsap.set(clone2, {
//       position: "absolute",
//       top: isHorizontal ? 0 : "200%",
//       left: isHorizontal ? "200%" : 0,
//       xPercent: 0,
//       yPercent: 0,
//     });

//     const timeline = gsap.timeline({
//       repeat: -1,
//       defaults: { ease: this.options.ease },
//     });

//     if (isHorizontal) {
//       timeline.to([group, clone1, clone2], {
//         x: `-=${dimension}`,
//         duration: this.options.baseSpeed,
//         ease: this.options.ease,
//         modifiers: {
//           x: gsap.utils.unitize((x) => parseFloat(x) % (dimension * 3)),
//         },
//       });
//     } else {
//       timeline.to([group, clone1, clone2], {
//         y: `-=${dimension}`,
//         duration: this.options.baseSpeed,
//         ease: this.options.ease,
//         modifiers: {
//           y: gsap.utils.unitize((y) => parseFloat(y) % (dimension * 3)),
//         },
//       });
//     }

//     wrapper.addEventListener("mouseenter", () => {
//       this.isHovering = true;
//       this.updateAllMarqueeSpeed();
//     });

//     wrapper.addEventListener("mouseleave", () => {
//       this.isHovering = false;
//       this.updateAllMarqueeSpeed();
//     });

//     this.animations.push({
//       wrapper,
//       list,
//       group,
//       clones: [clone1, clone2],
//       timeline,
//       isHorizontal,
//       dimension,
//       currentSpeed: 1,
//       direction: 1,
//     });
//   }

//   setupScrollListeners() {

//     if (this.options.smoothScroll && this.options.smoothScroll.lenis) {
//       this.options.smoothScroll.lenis.on("scroll", (e) => {

//         this.scrollVelocity = e.velocity * 2;

//         const newPosition = e.animatedScroll;
//         this.detectScrollDirection(newPosition);
//         this.lastScrollPosition = newPosition;
//       });
//     } else {

//       let lastScrollY = window.scrollY;
//       let lastScrollTime = performance.now();
//       let scrollTimeout;

//       window.addEventListener(
//         "scroll",
//         () => {
//           const now = performance.now();
//           const currentScrollY = window.scrollY;
//           const timeDelta = now - lastScrollTime;

//           if (timeDelta > 0) {

//             const rawVelocity = (currentScrollY - lastScrollY) / timeDelta;
//             this.scrollVelocity = Math.max(Math.min(rawVelocity * 15, 1), -1);

//             this.detectScrollDirection(currentScrollY);
//           }

//           lastScrollY = currentScrollY;
//           lastScrollTime = now;

//           clearTimeout(scrollTimeout);
//           scrollTimeout = setTimeout(() => {
//             this.scrollVelocity *= 0.5;
//             if (Math.abs(this.scrollVelocity) < 0.02) this.scrollVelocity = 0;
//           }, 80);
//         },
//         { passive: true }
//       );
//     }
//   }

//   detectScrollDirection(newPosition) {

//     if (
//       Math.abs(this.scrollVelocity) >= this.options.scrollDirectionThreshold
//     ) {

//       if (this.directionChangeTimeout) {
//         clearTimeout(this.directionChangeTimeout);
//         this.directionChangeTimeout = null;
//       }

//       const newDirection = this.scrollVelocity > 0 ? 1 : -1;

//       if (newDirection !== this.scrollDirection) {
//         this.scrollDirection = newDirection;
//         this.updateMarqueeDirection();
//       }
//     }
//   }

//   setupRAF() {
//     let lastTime = 0;
//     const fps = 60;
//     const interval = 1000 / fps;

//     const animate = (timestamp) => {
//       if (!lastTime) lastTime = timestamp;
//       const deltaTime = timestamp - lastTime;

//       if (deltaTime > interval) {

//         this.updateAllMarqueeSpeed();
//         lastTime = timestamp;
//       }

//       requestAnimationFrame(animate);
//     };

//     requestAnimationFrame(animate);
//   }

//   updateAllMarqueeSpeed() {
//     this.animations.forEach((animation) => {

//       let speedMultiplier = 1;

//       if (this.scrollVelocity !== 0) {

//         const velocityFactor =
//           Math.abs(this.scrollVelocity) * this.options.scrollInfluence;
//         speedMultiplier += velocityFactor;
//       }

//       if (this.isHovering) {
//         speedMultiplier *= this.options.hoverSlowFactor;
//       }

//       speedMultiplier = Math.max(
//         this.options.minSpeed,
//         Math.min(speedMultiplier, this.options.maxSpeed)
//       );

//       const currentSpeed = animation.currentSpeed || 1;
//       const targetSpeed = speedMultiplier;

//       animation.currentSpeed = gsap.utils.interpolate(
//         currentSpeed,
//         targetSpeed,
//         0.1
//       );

//       animation.timeline.timeScale(
//         animation.currentSpeed * animation.direction
//       );
//     });
//   }

//   updateMarqueeDirection() {
//     this.animations.forEach((animation) => {

//       animation.direction = this.scrollDirection;

//       animation.timeline.timeScale(
//         animation.currentSpeed * animation.direction
//       );
//     });
//   }

//   pause() {
//     this.animations.forEach((animation) => {
//       animation.timeline.pause();
//     });
//   }

//   play() {
//     this.animations.forEach((animation) => {
//       animation.timeline.play();
//     });
//   }

//   setSpeed(speed) {
//     this.options.baseSpeed = speed;
//     this.animations.forEach((animation) => {
//       animation.timeline.duration(speed);
//     });
//   }

//   destroy() {

//     this.animations.forEach((animation) => {
//       animation.timeline.kill();

//       animation.clones.forEach((clone) => {
//         if (clone && clone.parentNode) {
//           clone.parentNode.removeChild(clone);
//         }
//       });
//     });

//     if (this.wheelIndicator) {
//       this.wheelIndicator.destroy();
//     }

//     this.isInitialized = false;

//     this.animations = [];
//   }
// }

/* class FsAccordion {
  constructor(options = {}) {
    this.ATTRIBUTES_PREFIX = "fs-attributes";
    this.ACCORDION_MODULE = "accordion";
    this.ACCORDION_PREFIX = `fs-${this.ACCORDION_MODULE}`;
    this.GROUP_KEY = "group";
    this.ACCORDION_KEY = "accordion";
    this.TRIGGER_KEY = "trigger";
    this.CONTENT_KEY = "content";
    this.ARROW_KEY = "arrow";
    this.SINGLE_KEY = "single";
    this.DEFAULT_ACTIVE_CLASS = `is-active-${this.ACCORDION_MODULE}`;

    this.accordionGroups = new Map();
    this.cleanupFunctions = [];

    this.options = {
      ...options,
    };

    this.init();
  }

  init() {
    if (
      document.readyState === "complete" ||
      document.readyState === "interactive"
    ) {
      this.initializeAccordions();
    } else {
      const readyListener = () => {
        this.initializeAccordions();
        document.removeEventListener("DOMContentLoaded", readyListener);
      };
      document.addEventListener("DOMContentLoaded", readyListener);
      this.cleanupFunctions.push(() => {
        document.removeEventListener("DOMContentLoaded", readyListener);
      });
    }
  }

  addEventListenerWithCleanup(element, eventType, handler, options) {
    if (!element) return () => {};

    element.addEventListener(eventType, handler, options);
    const cleanup = () =>
      element.removeEventListener(eventType, handler, options);
    this.cleanupFunctions.push(cleanup);
    return cleanup;
  }

  isElementVisible(element) {
    return !!(
      element.offsetWidth ||
      element.offsetHeight ||
      element.getClientRects().length
    );
  }

  generateRandomId() {
    return Math.random().toString(36).substring(2, 15);
  }

  ensureElementId(element) {
    if (!element.id) {
      let id = this.generateRandomId();
      element.id = id;
      return id;
    }
    return element.id;
  }

  setupAccessibility(trigger, content) {
    let triggerId = this.ensureElementId(trigger);
    let contentId = this.ensureElementId(content);

    trigger.setAttribute("role", "button");
    trigger.setAttribute("aria-controls", contentId);
    trigger.setAttribute("tabindex", "0");
    content.setAttribute("aria-labelledby", triggerId);
  }

  openAccordionContent(element) {
    element.style.display = "block";
    element.style.maxHeight = "";

    let height = `${getComputedStyle(element).height}`;
    element.style.maxHeight = "0px";

    requestAnimationFrame(() => {
      element.style.maxHeight = height;
    });
  }

  closeAccordionContent(element) {
    const onTransitionEnd = this.addEventListenerWithCleanup(
      element,
      "transitionend",
      ({ propertyName }) => {
        if (propertyName === "max-height") {
          element.style.display = "none";
          onTransitionEnd();
        }
      }
    );

    let height = `${getComputedStyle(element).height}`;
    element.style.maxHeight = height;

    requestAnimationFrame(() => {
      element.style.maxHeight = "0px";
    });

    return onTransitionEnd;
  }

  toggleAccordionClasses(
    accordion,
    trigger,
    content,
    arrow,
    isOpen,
    activeClass
  ) {
    let method = isOpen ? "add" : "remove";
    accordion.classList[method](activeClass);
    trigger.classList[method](activeClass);
    content.classList[method](activeClass);
    if (arrow) arrow.classList[method](activeClass);
  }

  initializeAccordions() {
    const accordions = document.querySelectorAll(
      `[${this.ACCORDION_PREFIX}-element="${this.ACCORDION_KEY}"]`
    );

    Array.from(accordions).forEach((accordion) => {
      const group =
        accordion.closest(
          `[${this.ACCORDION_PREFIX}-element="${this.GROUP_KEY}"]`
        ) || document.body;

      let groupSettings = this.accordionGroups.get(group);
      if (!groupSettings) {
        const isSingleMode =
          group.getAttribute(`${this.ACCORDION_PREFIX}-${this.SINGLE_KEY}`) ===
          "true";
        const activeClass =
          group.getAttribute(`${this.ACCORDION_PREFIX}-active`) ||
          this.DEFAULT_ACTIVE_CLASS;

        groupSettings = {
          single: isSingleMode,
          activeClass,
          accordions: [],
        };
        this.accordionGroups.set(group, groupSettings);
      }

      const trigger = accordion.querySelector(
        `[${this.ACCORDION_PREFIX}-element="${this.TRIGGER_KEY}"]`
      );
      const content = accordion.querySelector(
        `[${this.ACCORDION_PREFIX}-element="${this.CONTENT_KEY}"]`
      );
      const arrow = accordion.querySelector(
        `[${this.ACCORDION_PREFIX}-element="${this.ARROW_KEY}"]`
      );

      if (!trigger || !content) return;

      this.setupAccessibility(trigger, content);

      let isOpen = false;

      content.style.display = "none";
      content.style.maxHeight = "0px";

      this.toggleAccordionClasses(
        accordion,
        trigger,
        content,
        arrow,
        isOpen,
        groupSettings.activeClass
      );

      const toggleAccordion = (triggerEvent) => {
        if (isOpen) {
          this.closeAccordionContent(content);
          isOpen = false;
        } else {
          this.openAccordionContent(content);
          isOpen = true;

          if (groupSettings.single && triggerEvent) {
            groupSettings.accordions.forEach((item) => {
              if (item.accordion !== accordion) {
                item.controls.close();
              }
            });
          }
        }

        this.toggleAccordionClasses(
          accordion,
          trigger,
          content,
          arrow,
          isOpen,
          groupSettings.activeClass
        );
      };

      const controls = {
        destroy: this.addEventListenerWithCleanup(
          trigger,
          "click",
          toggleAccordion
        ),
        open: () => {
          if (!isOpen) toggleAccordion();
        },
        close: () => {
          if (isOpen) toggleAccordion();
        },
        isOpen: () => isOpen,
      };

      groupSettings.accordions.push({
        accordion,
        controls,
      });
    });
  }

  destroy() {
    this.cleanupFunctions.forEach((cleanup) => cleanup());
    this.cleanupFunctions = [];

    this.accordionGroups.clear();
  }
} */

class SliderInitializer {
  constructor(options = {}) {
    this.options = {
      reviewsBreakpoint: 990,
      ...options,
    };

    this.reviewsSliders = [];
    this.productThumbs = [];
    this.productMedia = [];

    this.init();
  }

  init() {
    this.initreviewsSliders();
    this.initProductSliders();
  }

  initreviewsSliders() {
    if (window.innerWidth < this.options.reviewsBreakpoint) {
      $(".swiper-cover.is--reviews").each((index, element) => {
        const slider = new Swiper($(element).find(".swiper")[0], {
          speed: 400,
          loop: false,
          autoHeight: false,
          centeredSlides: false,
          followFinger: true,
          freeMode: false,
          slideToClickedSlide: false,
          slidesPerView: "auto",
          spaceBetween: 16,
          rewind: false,
          parallax: false,
          initialSlide: 0,
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
          breakpoints: {
            480: {
              slidesPerView: "auto",
              spaceBetween: 16,
            },

            768: {
              slidesPerView: "auto",
              spaceBetween: 20,
            },

            992: {
              slidesPerView: "auto",
              spaceBetween: 24,
            },
          },
          navigation: {
            nextEl: $(element).find(".swiper-next")[0],
            prevEl: $(element).find(".swiper-prev")[0],
            disabledClass: "is--disabled",
          },
          slideActiveClass: "is--active",
          slideDuplicateActiveClass: "is--active",
        });

        this.reviewsSliders.push(slider);
      });
    }
  }

  initProductSliders() {
    $(".swiper-cover.is--product").each((index, element) => {
      const thumbsSlider = new Swiper(
        $(element).find(".swiper.is--product_thumbs")[0],
        {
          speed: 400,
          loop: false,
          autoHeight: false,
          centeredSlides: false,
          followFinger: true,
          freeMode: false,
          slideToClickedSlide: true,
          slidesPerView: "auto",
          spaceBetween: 0,
          rewind: false,
          parallax: false,
          breakpoints: {
            480: {
              slidesPerView: "auto",
              spaceBetween: 0,
            },

            768: {
              slidesPerView: "auto",
              spaceBetween: 0,
            },

            992: {
              slidesPerView: "auto",
              spaceBetween: 0,
            },
          },
          slideActiveClass: "is--active",
          slideDuplicateActiveClass: "is--active",
        }
      );

      const mediaSlider = new Swiper(
        $(element).find(".swiper.is--product_media")[0],
        {
          speed: 400,
          loop: false,
          autoHeight: false,
          centeredSlides: false,
          followFinger: true,
          freeMode: false,
          slideToClickedSlide: false,
          slidesPerView: 1.15,
          spaceBetween: 8,
          rewind: false,
          parallax: false,
          breakpoints: {
            480: {
              slidesPerView: 1.25,
              spaceBetween: 12,
            },

            768: {
              slidesPerView: 1,
              spaceBetween: 0,
            },

            992: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
          },
          thumbs: {
            swiper: thumbsSlider,
          },
          pagination: {
            el: $(element).find(".sw-controller.lp_is--product")[0],
          },
          slideActiveClass: "is--active",
          slideDuplicateActiveClass: "is--active",
        }
      );

      this.productThumbs.push(thumbsSlider);
      this.productMedia.push(mediaSlider);
    });
  }

  updateSliders() {
    this.destroy();
    this.init();
  }

  destroy() {
    [
      ...this.reviewsSliders,
      ...this.productThumbs,
      ...this.productMedia,
    ].forEach((slider) => {
      if (slider && typeof slider.destroy === "function") {
        slider.destroy();
      }
    });

    this.reviewsSliders = [];
    this.productThumbs = [];
    this.productMedia = [];
  }
}

class CountdownTimer {
  constructor(
    targetDate,
    containerSelector = '[countdown="box"]',
    labelPhrase = "Limited-Time Offer Ends in: {h}h {m}m {s}s"
  ) {
    this.countDownDate = new Date(targetDate).getTime();
    this.containerSelector = containerSelector;
    this.labelPhrase = labelPhrase;
    this.intervalId = null;
    this.isRunning = false;
  }

  getElements(dataAttr) {
    const containers = document.querySelectorAll(this.containerSelector);
    let elements = [];

    containers.forEach((container) => {
      const found = container.querySelectorAll(`[countdown="${dataAttr}"]`);
      elements = [...elements, ...found];
    });

    return elements;
  }

  getLabelElements() {
    const labelsInContainers = Array.from(
      document.querySelectorAll(`${this.containerSelector} [countdown="label"]`)
    );
    const standaloneLabels = Array.from(
      document.querySelectorAll('[countdown="label"]')
    );

    return [...new Set([...labelsInContainers, ...standaloneLabels])];
  }

  formatLabelPhrase(days, hours, minutes, seconds) {
    let phrase = this.labelPhrase;

    phrase = phrase.replace(/{d}/g, days);
    phrase = phrase.replace(/{h}/g, hours);
    phrase = phrase.replace(/{m}/g, minutes);
    phrase = phrase.replace(/{s}/g, seconds);

    if (!phrase.includes("{d}") && days > 0) {
      phrase = phrase.replace(/{h}/g, days * 24 + hours);
    }

    return phrase;
  }

  update() {
    const containers = document.querySelectorAll(this.containerSelector);

    const now = new Date().getTime();
    const distance = this.countDownDate - now;

    if (distance < 0) {
      this.handleTimeUp();
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    if (containers.length > 0) {
      this.getElements("day").forEach(
        (element) => (element.textContent = days)
      );
      this.getElements("hour").forEach(
        (element) => (element.textContent = hours)
      );
      this.getElements("min").forEach(
        (element) => (element.textContent = minutes)
      );
      this.getElements("sec").forEach(
        (element) => (element.textContent = seconds)
      );
    }

    const formattedPhrase = this.formatLabelPhrase(
      days,
      hours,
      minutes,
      seconds
    );
    this.getLabelElements().forEach((element) => {
      element.textContent = formattedPhrase;
    });
  }

  handleTimeUp() {
    this.stop();

    const containers = document.querySelectorAll(this.containerSelector);
    containers.forEach((container) => {
      const timeupElement = container.querySelector(
        '[data-attribute="timeup"]'
      );
      if (timeupElement) {
        timeupElement.textContent = "Time's Up!";
      }
    });

    this.getLabelElements().forEach((element) => {
      element.textContent = "Offer Expired!";
    });
  }

  start() {
    if (this.isRunning) return;

    const containers = document.querySelectorAll(this.containerSelector);
    const labelElements = this.getLabelElements();

    if (containers.length === 0 && labelElements.length === 0) {
      console.warn(`No countdown elements found`);
      return;
    }

    this.update();
    this.intervalId = setInterval(() => this.update(), 1000);
    this.isRunning = true;
  }

  stop() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.isRunning = false;
    }
  }

  reset(newTargetDate) {
    this.stop();
    this.countDownDate = new Date(newTargetDate).getTime();
    this.start();
  }

  setLabelPhrase(newPhrase) {
    this.labelPhrase = newPhrase;
    this.update();
  }
}

class Marquee {

  constructor(element, options = {}) {

    this.options = {
      speed: 20,
      direction: 'left',
      pauseOnHover: false,
      autostart: true,
      ...options
    };

    this.element = typeof element === 'string' 
      ? document.querySelector(element) 
      : element;

    if (!this.element) {
      throw new Error('Element not found');
    }

    this.isRunning = false;
    this.isPaused = false;

    if (this.options.pauseOnHover) {
      this.element.addEventListener('mouseenter', () => this.pause());
      this.element.addEventListener('mouseleave', () => this.resume());
    }

    if (this.options.autostart) {
      this.start();
    }
  }

  _animate() {
    const direction = this.options.direction.toLowerCase();
    const distance = direction === 'left' ? -100 : 100;
    const duration = this.options.speed;

    const keyframes = [
      { transform: 'translateX(0%)' },
      { transform: `translateX(${distance}%)` }
    ];

    if (direction === 'right') {
      keyframes.reverse();
    }

    this.animation = this.element.animate(keyframes, {
      duration: duration * 1000, 
      iterations: Infinity,
      easing: 'linear'
    });

    this.isRunning = true;
  }

  start() {
    if (!this.isRunning) {
      this._animate();
    }
    return this;
  }

  stop() {
    if (this.animation) {
      this.animation.cancel();
      this.isRunning = false;
    }
    return this;
  }

  pause() {
    if (this.animation && !this.isPaused) {
      this.animation.pause();
      this.isPaused = true;
    }
    return this;
  }

  resume() {
    if (this.animation && this.isPaused) {
      this.animation.play();
      this.isPaused = false;
    }
    return this;
  }

  setSpeed(speed) {
    this.options.speed = speed;
    if (this.isRunning) {
      this.stop();
      this.start();
    }
    return this;
  }

  setDirection(direction) {
    if (direction !== 'left' && direction !== 'right') {
      throw new Error("Direction must be 'left' or 'right'");
    }
    this.options.direction = direction;
    if (this.isRunning) {
      this.stop();
      this.start();
    }
    return this;
  }

  destroy() {
    this.stop();

    if (this.options.pauseOnHover) {
      this.element.removeEventListener('mouseenter', this.pause);
      this.element.removeEventListener('mouseleave', this.resume);
    }
  }
}

const appEvents = new EventEmitter();

new DOMCleaner();
new SmoothScroll();
// const marquee = new GSAPMarquee({
//   wrapperAttr: 'marquee="wrapper"',
//   listAttr: 'marquee="list"',
//   groupAttr: 'marquee="group"',
//   childAttr: 'marquee="child"',
//   speed: 1,
//   direction: "horizontal",
//   pauseOnHover: true,
//   scrollSpeedFactor: 0.8,
//   reverseOnScrollUp: true,
//   smoothScroll: smoothScroll,
// });
new FsAccordion();
new SliderInitializer();
